import { render } from "./order_mhao.vue?vue&type=template&id=23bcab66&scoped=true"
import script from "./order_mhao.vue?vue&type=script&lang=js"
export * from "./order_mhao.vue?vue&type=script&lang=js"

import "./order_mhao.vue?vue&type=style&index=0&id=23bcab66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23bcab66"]])

export default __exports__